module.exports = __webpack_public_path__ + "img/center-down-arrow.14822ab8.png";